import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";
import action from "../../../../../actions";
import DEFINE, { CURRENCY, DETAIL_ACTIONS, ALL_CURRENCY_ENUM, DATE_TIME_FORMAT } from '../../../../../constants/Define';
import * as HMS from "../../../common/component/Index";
import * as ANT from 'antd';
import Input from '../../../common/component/Input';
import Select, { Option } from './../../../common/component/Select';
import $ from 'jquery'
import moment from 'moment';
import { toArray, get, find } from 'lodash';
import AntSelect, { AntOption } from '../../../common/component/AntSelect';

const defaultValue = {
    action: "CREATE",
    data: { isEnabled: true },
    allGroups: [],
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
    itemGroup: {},
    isUpload: false,
    isFetchingChange: false,
};

class ActionComponent extends Component {

    state = defaultValue;

    componentDidMount() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: "UPDATE" });
            // this.props.onGetItemUser({id: match.params.id, props: this.props});
        }
        this.props.onListAllGroups({ isCreateVoucher: true });
    }

    validation = (field, reload) => {
        const { t } = this.props;
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                required: {
                    voucherNumber: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.voucher.voucherNumber`)),
                    groupId: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.group.title`)),
                    currencyCode: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.voucher.currencyCode`)),
                }
            };
            let valueValidate = {};
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.vouchers.isSubmit,
            isGetItem: nextProps.groups.isGetItem,
            // isFetchingUpdate: nextProps.banners.isFetchingUpdate
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.groups !== prevProps.groups) {
            let newData = Func.customOptionSelectHMS(this.props.groups.allGroups, ['name', 'id', 'groupCode']);
            this.setState({
                allGroups: newData,
            });
        }
        if (this.props.groups.dataUpdate !== prevProps.groups.dataUpdate) {
            this.setState({
                itemGroup: this.props.groups.dataUpdate,
            })
        }
    }

    onChange = (e) => {
        let params = e && e.name ? e : Func.getValueForm(e);
        if (params.name === 'voucherNumber') {
            params.value = Func.formatNumber(params.value);
        }
        this.setState({
            data: {
                ...this.state.data,
                [params.name]: typeof params.value === 'string' ? params.value.trimLeft() : params.value,
            }
        });
        if (params.name === "groupId") {
            this.setState({
                isFetchingChange: true,
            });
            if (params.value) {
                this.props.onGetGroup({ id: params.value })
            } else {
                this.setState({
                    itemGroup: {},
                });
            }
        }
        this.validation(params.name, true)
    };

    selectFilterSearch = (input, option) => {
        const optionText = Func.vietnameseStringToUnicode(get(option, 'props.children.props.children').toLowerCase());
        const inputText = Func.vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    onSubmit = (e) => {
        e.preventDefault();
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                this.props.onCreateVoucher({
                    data: {
                        ...this.state.data,
                        voucherNumber: parseInt(this.state.data.voucherNumber)
                    },
                    props: this.props
                });
            }
        } else {
            ANT.message.error(i18n.t('validation.checkForm'))
        }
    };

    render() {
        const { t } = this.props;
        const { data, validation, isSubmit, isGetItem, action, allGroups, itemGroup } = this.state;
        const loadingAllGroup = this.props.groups.isFetchingUpdate;
        const remainVoucherAllData = find(itemGroup.remainVouchers || [], item => item.currencyCode === ALL_CURRENCY_ENUM)
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath={'vouchers'}
                            titleHeader={
                                action === "CREATE" ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.voucher.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.voucher.title')}`.toLowerCase()))
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            findParentRoute={() => Func.findParentRoute('vouchers', this.props)}
                            submitButtonRight={true}
                        >
                            <HMS.FormWrapperItem>
                                <div className="col-md-12">
                                    <HMS.HeaderComponent title={t('item.voucher.showInfo.info')} className="mb-3 p-2"
                                        style={{ borderBottom: '1px solid rgb(230, 230, 230)' }} />
                                </div>
                                <div className="col-md-5">
                                    {/* <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.groupId}
                                        validation={validation.groupId}
                                        labelTitle={t(`item.group.title`)}
                                    >
                                        <Select className="form-control" name="groupId" onChange={this.onChange}
                                            value={Func.checkUndefine(data.groupId)}>
                                            <Option value="">{Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.title")).toLowerCase())}</Option>
                                            {
                                                allGroups.length > 0 && allGroups.map((i, k) => {
                                                    return (
                                                        <Option value={i.value} key={k}>{i.name}</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </HMS.FormWrapperInputComponent> */}
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.groupId}
                                        validation={validation.groupId}
                                        labelTitle={t(`item.group.title`)}
                                    >
                                        <AntSelect className="select-group"
                                            showArrow showSearch
                                            loading={loadingAllGroup}
                                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.group.title")).toLowerCase())}
                                            value={data.groupId}
                                            onChange={id => this.onChange({ name: 'groupId', value: id })}
                                            style={{ width: '100%' }}
                                            filterOption={this.selectFilterSearch}
                                        >
                                            {(allGroups || []).map(g => (
                                                <AntOption key={g.value} value={g.value}>
                                                    <ANT.Tooltip title={g.name} placement="topLeft">{`${g.groupCode} - ${g.name}`}</ANT.Tooltip>
                                                </AntOption>
                                            ))}
                                        </AntSelect>
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-2">
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.currencyCode}
                                        validation={validation.currencyCode}
                                        labelTitle={t(`item.voucher.currencyCode`)}
                                    >
                                        <Select className="form-control" name="currencyCode" onChange={this.onChange}
                                            value={Func.checkUndefine(data.currencyCode)}
                                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.voucher.currencyCode")).toLowerCase())}
                                        >
                                            <Option value="" disabled>{Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.voucher.currencyCode")).toLowerCase())}</Option>

                                            {
                                                (toArray(CURRENCY)).map((key, index) => {
                                                    return (
                                                        <Option value={CURRENCY[key]} key={CURRENCY[key]}>{t(`item.group.currencies.${CURRENCY[key]}`)} ({CURRENCY[key]})</Option>
                                                    )
                                                })
                                            }
                                        </Select>
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-5">
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.voucherNumber}
                                        validation={validation.voucherNumber}
                                        labelTitle={t(`item.voucher.voucherNumber`)}
                                    >
                                        <Input type="text"

                                            autoComplete="off"
                                            placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.voucher.voucherNumber")).toLowerCase())}
                                            className={`form-control`}
                                            name="voucherNumber" onChange={this.onChange}
                                            value={Func.checkUndefine(data.voucherNumber)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                            </HMS.FormWrapperItem>
                            <HMS.LoadingComponent spinning={isGetItem} className="col-md-12" wrapperClassName="col-md-12 pl-0 pr-0">
                                {
                                    Object.keys(itemGroup).length > 0 && (
                                        <HMS.FormWrapperItem>
                                            <div className="col-md-12">
                                                <HMS.HeaderComponent title="2. Thông tin nhóm voucher" className="mb-3 p-2">
                                                    <ANT.Divider />
                                                    <ANT.Descriptions size="small">
                                                        <ANT.Descriptions.Item label={t('item.voucher.remainQuantity')}>{remainVoucherAllData && remainVoucherAllData.remain}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.startDate')}>{moment(itemGroup.startDate).format(DATE_TIME_FORMAT.SHORT_DATE)}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.endDate')}>{moment(itemGroup.endDate).format(DATE_TIME_FORMAT.SHORT_DATE)}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.typeReduced')}>{itemGroup.voucherType}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.discountValue')}>{Func.formatMoney(itemGroup.discountValue)}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.maxDiscountValue')}>{Func.formatMoney(itemGroup.maxDiscountValue)}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.limitNumberOfTimes')}>{itemGroup.limitNumberOfTimes}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.propertyOfStay')}>{itemGroup.propertyOfStay ? itemGroup.propertyOfStay.name : ''}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.checkInDate')}>{moment(itemGroup.checkInDate).format(DATE_TIME_FORMAT.SHORT_DATE)}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.checkOutDate')}>{moment(itemGroup.checkOutDate).format(DATE_TIME_FORMAT.SHORT_DATE)}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.operaBookingCode')}>{itemGroup.operaBookingCode}</ANT.Descriptions.Item>
                                                        <ANT.Descriptions.Item label={t('item.voucher.property')}>{itemGroup.properties.length > 0 ? itemGroup.properties.map((i) => i.name).join(', ') : ""}</ANT.Descriptions.Item>
                                                    </ANT.Descriptions>
                                                </HMS.HeaderComponent>
                                            </div>
                                        </HMS.FormWrapperItem>
                                    )
                                }
                            </HMS.LoadingComponent>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        vouchers: state.voucherReducer,
        products: state.productReducer,
        groups: state.groupReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListAllGroups: (filters) => {
            dispatch(action.dataAllGroupAction(filters))
        },
        onGetGroup: (id) => {
            dispatch(action.getUpdateGroupAction(id))
        },
        onCreateVoucher: (params) => {
            dispatch(action.createVoucherAction(params))
        },
        // onUploadFile: (filters) => {
        //     dispatch(action.uploadAction(filters))
        // },
        // onCreateBanner: (params) => {
        //     dispatch(action.createBannerAction(params))
        // },
        // onUpdateBanner: (id) => {
        //     dispatch(action.updateBannerAction(id))
        // },
        // onGetItemUser: (id) => {
        //     dispatch(action.getUpdateBannerAction(id))
        // },
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ActionComponent)));
